import { fetchApi } from "./fetchApi";
import debounce from "lodash/debounce";

export default {
  async get(id) {
    const result = await fetchApi({
      method: "get",
      url: `/api/pack/${id}`,
    });
    if (result.data.pilotParticipationList) {
      result.data.pilotParticipationList = JSON.parse(result.data.pilotParticipationList);
    }
    return result;
  },
  getPackTotals(packId, serviceAreaId) {
    return fetchApi({
      method: "get",
      url: `/api/pack/${packId}/serviceArea/${serviceAreaId}/total`,
    });
  },
  getPackBreakdown(packId, serviceAreaId, prop) {
    return fetchApi({
      method: "get",
      url: `/api/pack/${packId}/serviceArea/${serviceAreaId}/breakdown/${prop}`,
    });
  },
  getStatusByAssignee(packId, serviceAreaId) {
    return fetchApi({
      method: "get",
      url: `/api/pack/${packId}/serviceArea/${serviceAreaId}/statusByAssignee`,
    });
  },
  list: debounce(
    async () => {
      const response = await fetchApi({
        method: "get",
        url: "/api/pack",
      });

      return response.data.result;
    },
    100,
    { leading: true, trailing: false }
  ),
  post(pack) {
    if (pack.pilotParticipationList) {
      pack.pilotParticipationList = JSON.stringify(pack.pilotParticipationList.sort());
    }
    return fetchApi({
      data: pack,
      method: "post",
      url: "/api/pack",
    });
  },
  put(pack) {
    const url = `/api/pack/${pack.id}`;
    const data = Object.assign({}, pack);
    if (data.pilotParticipationList) {
      data.pilotParticipationList = JSON.stringify(data.pilotParticipationList.sort());
    }

    delete data.id;
    delete data.createdBy;
    delete data.dateCreated;

    return fetchApi({
      data,
      method: "put",
      url,
    });
  },
  async remove({ id }) {
    return fetchApi({
      method: "delete",
      url: `/api/pack/${id}`,
    });
  },
  async serviceAreaSummary(packId) {
    const response = await fetchApi({
      method: "get",
      url: `/api/pack/${packId}/serviceArea`,
    });

    return response.data.result;
  },
};
